const type = 'advanced'
const path = 'server/html'
const name = 'server.js'
const fullPath = `${path}/${name}`

const conditions = [
  {
    option: 'frontend',
    type: 'equals',
    value: 'html',
  },
  {
    parameter: 'buttons',
    type: 'includes',
    value: 'payment-buttons_3ds',
  },
]

export { type, path, name, fullPath, conditions }
